import { useEffect, useState } from "react";
import axios from "../../../axios"; // Adjust the path as necessary
import dayjs from "dayjs";

export default function SalesByCustomerPage() {
    const [data, setData] = useState([]);
    const [range, setRange] = useState({
        start: dayjs().startOf("month").format("YYYY-MM-DD"),
        end: dayjs().endOf("month").format("YYYY-MM-DD"),
    });
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await axios.get("/admin/sales-report/by-customer", {
                params: {
                    start: range.start,
                    end: range.end,
                },
            });
            setData(res.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const totalSales = data.reduce((acc, d) => acc + d.total_sales, 0);

    const handleInputChange = (e) => {
        setRange({ ...range, [e.target.name]: e.target.value });
    };

    return (
        <div className="card mt-24">
            <div className="card-header border-bottom">
                <h5>Laporan Penjualan per Customer</h5>
            </div>

            <div className="card-body">
                <div className="d-flex align-items-end gap-3 mb-3">
                    <div>
                        <label className="form-label">Dari</label>
                        <input
                            type="date"
                            name="start"
                            className="form-control"
                            value={range.start}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <label className="form-label">Sampai</label>
                        <input
                            type="date"
                            name="end"
                            className="form-control"
                            value={range.end}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div>
                        <button className="btn btn-main" onClick={fetchData}>Filter</button>
                    </div>
                </div>

                {loading ? (
                    <p>Loading...</p>
                ) : (
                    <>
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Customer</th>
                                    <th>Phone</th>
                                    <th>Total Order</th>
                                    <th>Total Penjualan</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item) => (
                                    <tr key={item.user_id}>
                                        <td>{item.user_name}</td>
                                        <td>{item.user_phone}</td>
                                        <td>{item.total_orders}</td>
                                        <td>Rp{item.total_sales.toLocaleString("id-ID")}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <h5>Total Penjualan Seluruh Customer: <strong>Rp{totalSales.toLocaleString("id-ID")}</strong></h5>
                    </>
                )}
            </div>
        </div>
    );
}
